import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ModelService {
    private sectorsOfInterest: string[] = [
        'Energy Savings',
        'Smart-readiness of buildings',
        'Well-insulated windows',
        'Solar-thermal facade',
        'Air Quality',
        'Descarbonation of electricity',
        'E-mobility',
        'Energy transition',
        'Renewable energy sources(RES)',
        'Wind energy',
        'Smart sensors',
        'Citizen engagement',
        'Citizen centric co-creation',
        'Other'
    ];

    private areasOfStudy: string[] = [
        'Technological',
        'Political',
        'Social Sciences',
        'Natural Sciences',
        'Economical',
        'Other'
    ];

    private fieldsOfWork: string[] = [
        'Student',
        'Sales',
        'Law & public policy',
        'Science and technology',
        'Business',
        'Research/University',
        'Educational',
        'Other'
    ];

    getSectorsOfInterest(): string[] {
        return this.sectorsOfInterest;
    }

    getAreasOfStudy(): string[] {
        return this.areasOfStudy;
    }

    getFieldsOfWork(): string[] {
        return this.fieldsOfWork;
    }
}
